import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./font/CSS/all.css";
import "./font/CSS/fontawesome.min.css";
import { ThemeProvider } from "./context/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {" "}
    <ThemeProvider>
      {" "}
      <App />{" "}
    </ThemeProvider>{" "}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/*import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
ReactDOM.render(
  <React.StrictMode>
    {" "}
    <ThemeProvider>
      {" "}
      <App />{" "}
    </ThemeProvider>{" "}
  </React.StrictMode>,
  document.getElementById("root")
);
*/
